var path = '/modules/bo/components/al-bo-preview/templates/option_set.tpl.html';
var html = "<div class=\"data-list\">\n    <table>\n        <tr ng-repeat=\"(index, option) in objectInformation.options\">\n            <td>{{(index === 0) ? objectInformation.object.label : ''}}</td>\n            <td>{{vm.calculateAmountForOptionSetOption(option)}}x {{option.option.label}}</td>\n        </tr>\n    </table>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/bo/components/al-bo-preview/templates/option_set.tpl.html
// module id = 2056
// module chunks = 1